<div class="page races js-page">
  <div class="racespanel">
    <div class="navblock">
      <button (click)="openCreateModal()" class="btnadd">{{'Add activity'|translate}}</button>
      <div></div>
      <div class="inputgroup">
        <input type="text" class="dtpickerupleft" value="" />
      </div>
      <button id="setintervalbtn" class="btn_blue">{{'Apply'|translate }}</button>
    </div>
    <div class="tablewrap">
      <div class="raceslist">
        <div *ngFor="let race of objects" class="raceblock">
          <app-race [object]="race"></app-race>
        </div>
      </div>
    </div>
    <div class="tablenav">
      <app-pagination [viewmode]="'print excel'" [printElementID]="'exporttable'"></app-pagination>
    </div>
  </div>
</div>

  <template #mgmtDialog>
  </template>
